



































































export default function (Component) {
  Component.options.__source = "src/App.vue"
}
